import { render, staticRenderFns } from "./BtDownloadSettings.vue?vue&type=template&id=5a46416f&"
import script from "./BtDownloadSettings.vue?vue&type=script&lang=js&"
export * from "./BtDownloadSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports